import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import DocumentCheckIcon from '@/container/Icon/Svg/DocumentCheckIcon';
import DocumentIcon from '@/container/Icon/Svg/DocumentIcon';
import HumanTalkIcon from '@/container/Icon/Svg/HumanTalkIcon';
import SearchIcon from '@/container/Icon/Svg/SearchIcon';
import { propNumber, propStr } from '@/helpers/custom-prop-types';
import { pagePath } from '@/utils/router/pagePath';
import Hover from '../../../../Ui/System/Hover';
import NavigationList from './NavigationList';
/**
 * TODO: TS化 & tailwind化
 */
const Navigation = (props) => {
    const { activeTab, rfpUnreadCount } = props;
    const navigationList = useMemo(() => [
        {
            className: 'is-mypage',
            count: 0,
            id: 'mypage',
            svg: _jsx(SearchIcon, {}),
            text: (_jsxs(_Fragment, { children: ["\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8", _jsx("br", {}), "\u30BB\u30DF\u30CA\u30FC\u30FB\u4E8B\u4F8B\u3092\u63A2\u3059"] })),
            to: '/mypage',
        },
        {
            count: 0,
            id: 'consultations',
            svg: _jsx(DocumentIcon, {}),
            text: (_jsxs(_Fragment, { children: ["\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u304B\u3089", _jsx("wbr", {}), "\u63D0\u6848\u3092\u52DF\u96C6\u3059\u308B"] })),
            to: '/mypage/consultation',
        },
        {
            count: rfpUnreadCount,
            id: 'project',
            svg: _jsx(DocumentCheckIcon, {}),
            text: (_jsxs(_Fragment, { children: ["\u63D0\u6848\u52DF\u96C6\u72B6\u6CC1\u3092", _jsx("br", {}), "\u78BA\u8A8D\u3059\u308B"] })),
            to: '/mypage/project',
        },
        {
            count: 0,
            id: 'hotline',
            svg: _jsx(HumanTalkIcon, {}),
            text: (_jsxs(_Fragment, { children: ["\u533F\u540D\u30B3\u30F3\u30B5\u30EB", _jsx("br", {}), "\u30DB\u30C3\u30C8\u30E9\u30A4\u30F3"] })),
            to: pagePath.mypage.client.hotline(),
        },
    ], [rfpUnreadCount]);
    return (_jsx("nav", Object.assign({ className: 'mypage_nav' }, { children: _jsx("ul", { children: navigationList.map((navigation) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'svg_hover' }, { children: _jsx(NavigationList, { className: clsx(navigation.className, activeTab === navigation.id && 'is-active'), count: navigation.count, disabled: !!navigation.disabled, external: !!navigation.external, svg: navigation.svg, text: navigation.text, to: navigation.to }) })) }, navigation.id))) }) })));
};
Navigation.propTypes = {
    activeTab: propStr().isRequired,
    rfpUnreadCount: propNumber().isRequired,
};
export default Navigation;
